<script>
    import { truncText, getTopAreaHeight } from "../../utils/utils";
    import { wrapGrid } from "animate-css-grid";

    export default {
        props: {
            rawIsGated: { type: Boolean, default: false },
            rawTitle: { type: String, default: '' },
            rawIngress: { type: String, default: '' },
            titleLimit: { type: Number, default: 120 },
            ingressLimit: { type: Number, default: 140 },
            gatedUrl: { type: String, default: '' },
            formId: { type: String, default: '' },
            formUrl: { type: String, default: '' },
            hasImage: { type: Boolean, default: false },
            imageUrl: { type: String, default: '' },
            marketingFormExtendable: { type: Boolean, default: false }
        },
        data() {
            return {
                busy: false,
                isGatedUrlValid: false,
                isFormIdValid: false,
                isFormUrlValid: false,
                isTitleValid: false,
                isIngressValid: false,
                isBlockIdValid: false,
                isMarketingDataValid: false,
                zoom: false,
                isGated: this.rawIsGated,
                title: "",
                ingress: "",
                modalOpen: false,
                isExtended: false,
                expandingStarted: false,
                expandingFinished: false,
                transitionFinished: false,
                formHeight: 0,
                gridElementInitialHeight: 0
            };
        },
        methods: {
            getExtendedFormSize() {
                const form = this.$refs.vueCardWithCTAExtendable;
                form.classList.add("collapsed");
                const w = form.querySelector(".extendableForm__content").offsetWidth;
                const h = form.querySelector(".iframe-form-block-formfill").offsetHeight +
                    form.querySelector(".form-heading").offsetHeight;
                form.classList.remove("collapsed");
                return { w, h };
            },
            prepareExtendableForm() {
                if (!this.isGated) return;
                const cardElement = this.$el;
                const successElement = document.getElementById(this.formId + "-form-success");
                const gridElement = this.$el.parentNode.parentNode;
                const gridContainer = gridElement.parentNode;

                window.addEventListener("DOMContentLoaded", () => {
                    this.gridElementInitialHeight = gridElement.offsetHeight;
                });

                if (!gridContainer.classList.contains("containsExtendable")) {
                    gridContainer.classList.add("containsExtendable");
                    wrapGrid(gridContainer, { stagger: 0, duration: 500, easing: "easeInOut" });
                }

                successElement?.addEventListener("gating-removed", () => {
                    cardElement.classList.add("gating-removed");
                    gridElement.style.height = this.gridElementInitialHeight + "px";
                    const content = gridElement.querySelector(".extendableForm__content");
                    if (content) content.style.height = this.gridElementInitialHeight + "px";
                });

                window.addEventListener("message", event => {
                    if ((event.data.task !== "pardotFormHeight" && event.data.task !== "formHeight") ||
                        event.data.formID !== this.formId) return;

                    if (this.isExtended && this.transitionFinished) {
                        const privacyPolicy = cardElement.querySelector(".privacy-policy-text");
                        const formHeading = cardElement.querySelector(".form-heading");
                        this.formHeight = event.data.formHeight +
                            (formHeading ? formHeading.offsetHeight : 0) +
                            (privacyPolicy ? privacyPolicy.offsetHeight : 0);
                        if (window.innerWidth >= 722) {
                            this.expandedCardHeight = this.formHeight +
                                cardElement.querySelector(".extendableForm__title").offsetHeight;
                            gridElement.style.height = this.expandedCardHeight + "px";
                            const content = cardElement.querySelector(".extendableForm__content");
                            if (content) content.style.height = this.formHeight + "px";
                        }
                    }
                });
            },
            prepareToDisplay() {
                if (this.isTitleValid) this.title = truncText(this.rawTitle, this.titleLimit);
                if (this.isIngressValid) this.ingress = truncText(this.rawIngress, this.ingressLimit);
            },
            setHTMLAttributesValidity() {
                const blockId = this.$el?.parentNode?.id || "";
                const { formId, formUrl, rawTitle, rawIngress, gatedUrl } = this;
                if (blockId) this.isBlockIdValid = true;
                if (formId) this.isFormIdValid = true;
                if (formUrl) this.isFormUrlValid = true;
                if (rawTitle) this.isTitleValid = true;
                if (rawIngress) this.isIngressValid = true;
                if (gatedUrl) this.isGatedUrlValid = true;
            },
            verifyDataAndLog() {
                if (!this.isGated) return;
                if (!this.isBlockIdValid) return console.error("Block ID is invalid!", this.$el.id);
                if (!this.isGatedUrlValid) return console.error("Gated URL invalid!", this.gatedUrl);
                if (!this.isFormIdValid) return console.error("Form ID invalid!", this.formId);
                if (!this.isFormUrlValid) return console.error("Form URL invalid!", this.formUrl);
            },
            removeGatingOnEvent() { this.removeGating(); },
            removeGating() {
                const $parent = $(this.$el.parentElement);
                $parent.addClass("formSubmitted");
                if (!this.isGated) return;
                this.isGated = false;
            },
            toggleMarketingForm(open) {
                if (!this.isFormIdValid) return;
                const iframe = document.getElementById(this.formId);
                if (!(iframe && this.isFormUrlValid)) return;
                iframe.setAttribute("src", open ? this.formUrl : "about:blank");
                setTimeout(() => this.toggleIframeLoader(!open), 500);
            },
            toggleIframeLoader(show) {
                const loader = this.$el.querySelector(".form-heading__loader");
                if (!loader) return;
                loader.classList.toggle("hidden", !show);
            },
            setItemGridPosition(item) {
                let itemColumn = 1;
                let itemRow = 1;
                const itemIndex = item.index();
                const $grid = item.parent();
                if (window.innerWidth >= 1200) {
                    const columnsPerRow = 12;
                    $grid.find(".block").each((index, currentItem) => {
                        if (index === itemIndex) return false;
                        const $c = $(currentItem);
                        let size;
                        if ($c.hasClass("one-third")) size = 4;
                        else if ($c.hasClass("two-thirds")) size = 8;
                        else if ($c.hasClass("one-half")) size = 6;
                        else size = 3;
                        itemColumn += size;
                    });
                    itemRow = Math.ceil(itemColumn / columnsPerRow);
                    item.css({
                        "grid-column-start": "1",
                        "grid-column-end": "span " + columnsPerRow,
                        "grid-row-start": itemRow
                    });
                } else {
                    const columnsPerRow = 8;
                    $grid.find(".block").each((index, currentItem) => {
                        if (index === itemIndex) return false;
                        const size = $(currentItem).hasClass("two-thirds") ? 8 : 4;
                        itemColumn += size;
                    });
                    itemRow = Math.ceil(itemColumn / columnsPerRow);
                    item.css({
                        "grid-column-start": "1",
                        "grid-column-end": "span " + columnsPerRow,
                        "grid-row-start": itemRow
                    });
                }
            },
            expandExtendableForm() {
                if (!this.isGated) return;
                this.expandingStarted = true;
                const parent = $(this.$el).closest('.block');
                const formContent = parent.find(".extendableForm__content");
                const formTitle = parent.find(".extendableForm__title");
                const formSize = this.getExtendedFormSize();
                let waitForCollapse = false;
                if (parent.siblings(".extended").length) {
                    waitForCollapse = true;
                    window.dispatchEvent(new Event("hide-extendable-form", { bubbles: true }));
                }
                if (window.innerWidth >= 722) {
                    this.setItemGridPosition(parent);
                    parent.addClass("extended");
                    setTimeout(() => {
                        window.dispatchEvent(new Event("expanding-started", { bubbles: true }));
                        this.expandingFinished = false;
                        this.transitionFinished = false;
                        this.isExtended = true;
                        formTitle.width(this.getExtendedFormSize().w + "px");
                        parent.addClass("transition expanding");
                        this.toggleMarketingForm(true);
                        setTimeout(() => {
                            parent.removeClass("transition expanding");
                            formContent.height(formSize.h + "px");
                            this.transitionFinished = true;
                            setTimeout(() => {
                                window.dispatchEvent(new Event("expanding-finished", { bubbles: true }));
                                this.expandingFinished = true;
                                parent.addClass("expandingFinished");
                                this.$refs.vueCardWithCTAExtendable.focus();
                                this.$refs.vueCardWithCTAExtendable.addEventListener('keyup', this.handleEscapePress);
                                formTitle.width("");
                                $("html, body").stop().animate(
                                    { scrollTop: parent.offset().top - getTopAreaHeight() },
                                    500,
                                    "swing"
                                );
                            }, 0);
                        }, 500);
                    }, waitForCollapse ? 1500 : 0);
                } else {
                    setTimeout(() => {
                        this.isExtended = true;
                        parent.addClass("extended");
                        formContent.css(
                            "padding-bottom",
                            formContent.find(".privacy-policy-text").outerHeight() + "px"
                        );
                        setTimeout(() => {
                            this.expandingFinished = true;
                            parent.addClass("expandingFinished");
                            this.$refs.vueCardWithCTAExtendable.focus();
                            this.$refs.vueCardWithCTAExtendable.addEventListener("keyup", this.handleEscapePress);
                            parent.height("");
                            this.toggleMarketingForm(true);
                            $("html, body").stop().animate(
                                { scrollTop: parent.offset().top - 100 },
                                500,
                                "swing"
                            );
                        }, 0);
                    }, waitForCollapse ? 0 : 0);
                }
            },
            collapseExtendableForm() {
                const parent = $(this.$el).closest('.block');
                const formContent = parent.find(".extendableForm__content");
                const formTitle = parent.find(".extendableForm__title");
                const formWidth = formTitle.outerWidth();
                parent.removeClass("expandingFinished");
                this.$refs.vueCardWithCTAExtendable.removeEventListener("keyup", this.handleEscapePress);
                formTitle.width(formWidth + "px");
                if (window.innerWidth >= 722) {
                    parent.addClass("transition collapsing");
                    formContent.height("0");
                    setTimeout(() => {
                        this.isExtended = false;
                        parent.removeClass("extended");
                        this.toggleMarketingForm(false);
                        parent.height("auto");
                        setTimeout(() => {
                            parent.removeClass("transition");
                            setTimeout(() => {
                                $(this.$el).css({ "max-width": "none" });
                                parent.css({
                                    "grid-column-start": "",
                                    "grid-column-end": "",
                                    "grid-row-start": ""
                                });
                                parent.removeClass("collapsing");
                                this.expandingStarted = false;
                                formTitle.width("");
                            }, 500);
                        }, 0);
                    }, 500);
                } else {
                    this.isExtended = false;
                    this.expandingStarted = false;
                    formContent.height(0);
                    this.toggleMarketingForm(false);
                    parent.removeClass("extended");
                    parent.height("");
                }
            },
            handleEscapePress(e) {
                if (e.key === "Escape" || e.keyCode === 27) {
                    this.collapseExtendableForm();
                }
            }
        },
        mounted() {
            this.setHTMLAttributesValidity();
            this.verifyDataAndLog();
            this.prepareToDisplay();
            if (this.marketingFormExtendable) this.prepareExtendableForm();

            this.$el.addEventListener("remove-card-with-cta-gating", this.removeGatingOnEvent);
            window.addEventListener("hide-extendable-form", () => {
                if (this.isExtended) this.collapseExtendableForm();
            });
            window.addEventListener("expanding-started", () => {
                this.$el.style.height = $(this.$el).outerHeight() + "px";
            });
            window.addEventListener("expanding-finished", () => {
                this.$el.style.height = "";
            });
            window.addEventListener("resize", () => {
                setTimeout(() => {
                    if (this.busy) return;
                    this.busy = true;
                }, 0);
                if (this.isExtended && window.innerWidth >= 722) {
                    this.collapseExtendableForm();
                }
            });
        }
    };
</script>